export default {
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    env: process.env.REACT_APP_ENV
}